import { Select } from '@volkswagen-onehub/components-core';
import { default as React } from 'react';
import styled from 'styled-components';
import {
	CarlineWithOfertas,
	Oferta,
} from '../../services/ofertas-service/models/ofertas';

const ModelSelectorContainer = styled.div`
	padding: 0 20px;
	border: 1px solid #001e50;
	border-radius: 500px;

	& select {
		border: none;
	}

	& select:hover,
	select:focus-within {
		border-color: none;
	}

	& option {
		font-size: 16px;
	}

	& label,
	label:hover,
	label:focus-within {
		box-shadow: none;
	}

	@media screen and (max-width: 559px) {
		padding: 0;

		& select {
			padding: 0;
		}

		& div {
			align-self: center;
		}

		& label {
			padding: 0 10px;
			height: 32px;
			display: flex;
			width: fit-content;
			display: flex;
			flex-direction: row;

			& span {
				height: 12px;
				width: 12px;
				position: unset;
				align-self: center;
			}
		}
	}
`;

export const ModelSelector = ({
	carlines,
	activeCarlineIndex,
	setActiveCarlineIndex,
	setSelectedOferta,
}: {
	carlines: CarlineWithOfertas[];
	activeCarlineIndex: number;
	setActiveCarlineIndex: (actviteCarlineIndex: number) => void;
	setSelectedOferta: (oferta: Oferta) => void;
}): React.ReactElement => {
	const handleSelectOnChange = (
		event: React.SyntheticEvent<HTMLSelectElement, Event>,
	) => {
		const target = event.target as HTMLSelectElement;
		setActiveCarlineIndex(Number(target.value));
		setSelectedOferta(carlines[Number(target.value)].ofertas[0]);
	};

	return (
		<ModelSelectorContainer className="model-selector-container">
			<Select
				onChange={handleSelectOnChange}
				value={String(activeCarlineIndex)}
			>
				{carlines.map((carline, index) => {
					return (
						<option key={carline.id} value={index}>
							{carline.nuevo ? 'NUEVO ' : ''}
							{carline.title.toUpperCase()}
						</option>
					);
				})}
			</Select>
		</ModelSelectorContainer>
	);
};
